import { API } from "../axios/API";

const getProfesional = async (dni) => {
  // return arrayData;
  try {
    const resp = await API.post("/profesionales", { dni });
    return resp;
  } catch (err) {
    console.log(err);
    return err.response;
  }
};


const getAbogados = async () => {
  // return arrayData;
  try {
    const resp = await API.get("/profesionales/abogados");
    return resp.data;
  } catch (err) {
    return err.response;
  }
};

const searchAbogados = async (data) => {
  // return arrayData;
  try {
    const resp = await API.post("/profesionales/search", data);
    return resp.data;
  } catch (err) {
    return err.response;
  }
};

const getTitulos = async () => {
  // return arrayData;
  try {
    const resp = await API.get("/profesionales/titulos");
    return resp.data;
  } catch (err) {
    return err.response;
  }
};


const createAbogado = async (newData) => {
  const resp = await API.post("/profesionales/createAbogado", newData);

  return resp;
};

const editAbogado = async (newData) => {
  const resp = await API.post("/profesionales/editAbogado", newData);

  return resp;
};

const deleteAbogado = async (data) => {
  const result = await API.post("/profesionales/deleteAbogado", data);

  return result;
};

const getAbogadosNameDNI = async () => {
  // return arrayData;
  try {
    const resp = await API.get("/profesionales/abogadosnamedni");
    return resp.data;
  } catch (err) {
    return err.response;
  }
};


export const AbogadoService = {
  getProfesional,
  getAbogados,
  createAbogado,
  editAbogado,
  deleteAbogado,
  getTitulos,
  searchAbogados,
  getAbogadosNameDNI
};
